var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 527,
    height: 399,
    viewBox: "0 0 527 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M526.5 240.5C494.5 365 389.624 398.5 251 398.5C112.377 398.5 18 340.5 3.63683e-05 218.5C3.63683e-05 119.089 112.377 0 251 0C389.624 0 526.5 141.089 526.5 240.5Z",
    fill: "#F7F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.fafba796a89843735926f997db99ce15.svg";
export { ForwardRef as ReactComponent };